/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { LOADMORE_STYLE_CLASS } from '../PRIVATE_LoadMoreCollection';

type Props = {
  /**
   * Allows to pass skeletons
   **/
  children: ComponentChildren;
};

/**
 * Allows to specify the time delay for rendering the component
 **/
const timerValue = 50;

/**
 * BaseCardViewSkeletonContainer renders skeletons after 50ms threshold defined in the Redwood spec
 **/
export function BaseCardViewSkeletonContainer({ children }: Props) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, timerValue);
  }, []);

  return isVisible ? <Fragment>{children}</Fragment> : <div class={LOADMORE_STYLE_CLASS}></div>;
}
